import { AccountSettings } from '@retink/web-ui'
import { api } from '../lib/api'

export function Settings() {
  return <AccountSettings api={api} />
}
